// extracted by mini-css-extract-plugin
module.exports = {"inner":"styles_inner__C__Mg","errorLogs":"styles_errorLogs__2yik_"};